var customerPrefix;
var YesClicked = false;
var asyncFlag = false;
var asyncAPI = false;
var fitSmartProfilesData;
var fitSmartProfiles;
var pdpTypeLow = $('body').attr('data-type');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

// console.log('appcustomer',fitsmartCustomerId);

$('.drawer-logout').click(function(e){
  e.preventDefault();
  // clearCart();
  localStorage.removeItem("getprofile");
  console.log('clear cart');
  document.cookie = "cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  localStorage.guestCartProductsAdded = false;
  location.href = `${location.origin}/account/logout`;
  
});

function clearCart(){
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    dataType: 'json',
    success: function(){}
  });
}
  
function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?]' + name + '(=([^?#]*)|&|#|$)'),
   results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, '+'));
}
function editCustomize(){
  console.log('in edit customize');
  jQuery.getJSON('/cart.js', function(cart_edit) {
    cart = cart_edit;
    $(document).on('click','.customDatadrawer1',function(){
      $('body').addClass('custom-data-drawer');
      var cart_index = $(this).closest('.CartItem').attr('cart-index');
      console.log('cart_index',cart_index);
      console.log('cart',cart);
      console.log('cartItem',cart.items);
      var cart_image = $(this).closest('.CartItem').find('.CartItem__Image').attr('src');
      //console.log('cart_image',cart_image);
      var cart_title = $(this).closest('.CartItem').find('.CartItem__Title').attr('data-cartitem-title');
      //console.log('cart_title',cart_title);
      var dr_top_html = "";
      if(cart_image != null && cart_title != null ){
        dr_top_html += `<div class="img">`
        dr_top_html +=   `<img src="${cart_image}">`
        dr_top_html +=  `</div>`
        dr_top_html +=  `<div class="content">`
        dr_top_html +=    `<h5>${cart_title}</h5>`
        dr_top_html +=  `</div>`
        $('.cartItem_content').html(dr_top_html);
      }
      var cartItem_link = $(this).closest('.CartItem').find('.CartItem__ImageWrapper a').attr('data-href');
      var cartItem_gift_title = $(this).closest('.CartItem').find('.customized-details').attr('data-gift-details');
      
      if(typeof cartItem_gift_title == "undefined"){
      $('.order-cust-detail .title').find('h3').text('Customisations');
      }else{
      $('.order-cust-detail .title').find('h3').text('Gift Card Details');
      } 
      console.log('cartItem_link',cartItem_link);
      $('.order-cust-detail .edt-cust').attr('href',cartItem_link+'&editCustomisations=true');
      console.log('cartinexdata',cart.items[cart_index]);
      var getCustomAttr = cart.items[cart_index]['properties']['_customized_attributes'];
      var getRecipientDetials= cart.items[cart_index]['properties']['__shopify_send_gift_card_to_recipient'];
      var getRecipientEmail= cart.items[cart_index]['properties']['Recipient email'];
      var getRecipientName= cart.items[cart_index]['properties']['Recipient name'];
      var getRecipientSendOn= cart.items[cart_index]['properties']['Send on'];
      var getRecipientCustomMessage= cart.items[cart_index]['properties']['Message'];
      var getPincode = cart.items[cart_index]['properties']['pincode'];
      console.log('getCustomAttr',getCustomAttr);
      var dr_html = "";
      
      if(getRecipientDetials == 'on'){
        if(getRecipientEmail != ''){
          console.log('getRecipientEmail',getRecipientEmail);
          dr_html += `<li><div class="inner-title"><span>Recipient Email</span> <span style="text-transform: initial !important;">${getRecipientEmail}</span></div></li>`;
        }if(getRecipientName != ''){
          console.log('getRecipientName',getRecipientName);
          dr_html += `<li><div class="inner-title"><span>Recipient Name</span> <span style="text-transform: initial !important;">${getRecipientName}</span></div></li>`;
        }if(getRecipientSendOn != ''){
          // var second_date = moment(getRecipientSendOn).format('DD-MM-YYYY');
          var second_date = getRecipientSendOn;
          console.log('getRecipientSendOn',second_date);
          dr_html += `<li><div class="inner-title"><span>Send On</span> <span>${second_date}</span></div></li>`;
        }if(getRecipientCustomMessage != ''){
          dr_html += `<li><div class="inner-title"><span>Custom Message</span> <span>${getRecipientCustomMessage}</span></div></li>`;
          console.log('getRecipientCustomMessage',getRecipientCustomMessage);
        }
        $('.style_details').html(dr_html);
        $('.order-cust-detail .edt-cust').text('Edit Details');
      }else if(getPincode != undefined){
        console.log("pincode",getPincode);
        dr_html += `<li><div class="inner-title">
        <span>Pincode</span>
        <span style="text-transform: initial !important;">${getPincode}</span></div>
        </li>
        <li><div class="inner-title">
        <span>Appointment Date</span>
        <span style="text-transform: initial !important;">${cart.items[cart_index]['properties']['appointmentDate']}</span></div>
        </li>
        <li><div class="inner-title">
        <span>Appointment Time</span>
        <span style="text-transform: initial !important;">${cart.items[cart_index]['properties']['appointmentSlot']}</span></div>
        </li>`;
        $('.style_details').html(dr_html);
        $('.order-cust-detail .edt-cust').text('Edit Appointment Details');
        let paraURL = `&pincode=${getPincode}&date=${cart.items[cart_index]['properties']['appointmentDate']}&slot=${cart.items[cart_index]['properties']['appointmentSlot']}`;
        $('.order-cust-detail .edt-cust').attr('href',`/pages/travelling-stylist?editCustomisations=true${paraURL}`);
        $('.order-cust-detail .title').find('h3').text('Appointment Details');
      }else{
        $('.order-cust-detail .edt-cust').text('Edit Customisations');
      }
      
      if(getCustomAttr != null){
        var getCustomData = JSON.parse(getCustomAttr);
        var sleeveFlag = 0;
        getCustomData = getCustomData['attributes'];
        console.log(getCustomData);
        if(getCustomData[17]){
          var editSleeves = getParameterByName('imageValue',getCustomData[17]['values']);
          if(editSleeves == 'Short Sleeves'){
          sleeveFlag = 1;
          }
        }
        if(getCustomData[28]){
          var editMono = getCustomData[28]['values'][0];
        }else if(getCustomData[0]){
          var editMono = getCustomData[0]['values'][0];
          console.log("dfhdkjfhsdkf",getCustomData[0]['attributeName'])
        }
        arr = jQuery.grep(getCustomData, function(n, i){
          return (n !== "" && n != null );
        });
        console.log('arr',arr);
        var dr_html = "";
        $.each(arr, function(index, value) {
          console.log("value>>>",value);
          console.log("sleeveFlag",sleeveFlag);
          var attrName = value.attributeName;
          var attrValue = value.values[0];
          var imgVal = getParameterByName('imageTitle',attrValue);
          var monoImg; 
          if (attrName.indexOf('Cuff') > -1  && sleeveFlag == 1) {
            return;
          }
          if(attrName != null && imgVal != null && attrValue != null ){
            dr_html += `<li><div class="inner-title"><span>${attrName}</span> <span>${imgVal}</span></div><div class="img-right"><img src="${attrValue}"></div> </li>`;
            $('.style_details').html(dr_html);
          }else if(attrName == 'Monogram'){
            if(editMono ){
            if(editMono == 'LEFTCUFF'){
            monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/leftcuff.svg';
            }else if(editMono == 'Collar'){
            monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/collar.svg';
            }else if(editMono == 'Rib' ){
            monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/rib.svg';
            }else if(editMono == 'Pocket'){
            monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/pocket.svg';
            }else if(editMono == 'Chest'){
            monoImg = 'https://bsc-admin-productimagedev-dev.s3.ap-south-1.amazonaws.com/public/pwa-assets/images/monogram-placement/chest.svg';
            }
            dr_html += `<li><div class="inner-title"><span>${attrName}</span> <span>${editMono}</span></div><div class="img-right"><img src="${monoImg}"></div></li>`
            }
            
            $('.style_details').html(dr_html);
          }
        });
        
        if(getCustomData[0]['attributeName'] == 'Monogram'){
          var tColor = getCustomData[0]['values'][3];
          var tText = getCustomData[0]['values'][2];
          dr_html += `<li><div class="inner-title">
          <span>Initials</span>
          <span>${tText}</span>
          </div</li>`
          if(tColor == 'FFFFFF'){
          tImg = 'https://cdn.shopify.com/s/files/1/0538/8841/7962/files/Rectangle_1664.svg?v=1713179304';
          console.log("1");
          }else if(tColor == '231F20'){
          tImg = 'https://cdn.shopify.com/s/files/1/0538/8841/7962/files/Rectangle_1665.svg?v=1713179304';
          console.log("2");
          }else if(tColor == '0066CC'){
          tImg = 'https://cdn.shopify.com/s/files/1/0538/8841/7962/files/Rectangle_1663.svg?v=1713179304';
          console.log("3");
          }else if(tColor == 'F9DAF0'){
          tImg = 'https://cdn.shopify.com/s/files/1/0538/8841/7962/files/Rectangle_1666.svg?v=1713179304';
          console.log("4");
          }else if(tColor == 'DD2D28'){
          tImg = 'https://cdn.shopify.com/s/files/1/0538/8841/7962/files/Rectangle_1667.svg?v=1713179304';
          console.log("5");
          }
          dr_html += `<li><div class="inner-title"><span>Thread Color</span> <span>${tColor}</span></div><div class="img-right"><img src="${tImg}"></div>  </li>`                  
          $('.style_details').html(dr_html);
        }
      }
    });
  });
}
editCustomize();
        
$('.cust-drawer-overlay').click(function(){
  $('.close_dr').click();
});

function createMeasurementFitsmart(createMeasureOBJ,customerMetaKey1){
  console.log("createMeasurement1>>>>>>>>",createMeasureOBJ);
  var customRequestToken = requestToken;
  customRequestToken.metadata = customerMetaKey1;
  $.ajax({
    url: baseUrlBsc+ '/sizing/v4/createMeasurmentShopify',
    type: 'POST',
    data: JSON.stringify(createMeasureOBJ),
    contentType: "application/json",
    dataType: "json",
    headers: customRequestToken,
    success: function(data, textStatus, xhr) {
      if(data.success != null){
        localStorage.needToGetCustomerProfileData = true;
        console.log('create measure success',data.success);
        localStorage.setItem("getprofile", JSON.stringify(data.success));
        manageCartFitsmart();
      }else{
        if(data.error.errorCode == "406" || data.error.errorCode == "500"){
          console.log("error code 406>>>",data.error);
          var fetchURL = `${window.location.href}`;
          fetch(fetchURL,{
          method:'GET', headers: {
          'Content-Type': 'application/json'}
          })
          .then((response) =>{
          return response.text();
          }).then(data =>{
            let parser = new DOMParser();
            let parsedHtml = parser.parseFromString(data, 'text/html');
            customerMetaKey = parsedHtml.querySelector('body').getAttribute("data-customer-key");
            console.log("parsedHtml",parsedHtml,"customerMetaKey",customerMetaKey);
            // createMeasureOBJ.metadata = customerMetaKey;
            // debugger;
            createMeasurementFitsmart(createMeasureOBJ,customerMetaKey);
          });
        }
      }
    },
    error: function(err) {
      console.log(err);
    }
  });
}

/*
=================================================
CART PAGE FITSMART MANAGE ======> START
=================================================
*/
function manageCartFitsmart(){
  console.log("manageCartFitsmart>>>>>>>>>>>>>>>>>")
  $.ajax({
    url: '/cart.js',
    type: 'GET',
    contentType: "application/json",
    dataType: "json",
    success: function(data) {
      console.log('CART items',data.items);
      // item_count
      if(document.querySelector(".cart-count")) document.querySelector(".cart-count").innerHTML = data.item_count;
      if(document.querySelector("[cart-count-item]")) document.querySelector("[cart-count-item]").setAttribute("cart-count-item",data.item_count);
      let cartItems = data.items;
      var newCartObject = [];
      var needToUpdateCart = false;
      var itemSoldout = false;
      if(document.body.classList.contains("notlogged")){
        var fitsmartObject = localStorage.getItem("fitsmartobjNew") ? JSON.parse(localStorage.getItem("fitsmartobjNew")) : null;
        console.log("fitsmartObject",fitsmartObject);
        if(fitsmartObject && cartItems.length > 0){
          cartItems.forEach((cartItem,index) => {
            itemSoldout = false;
            console.log("index",index,"cartItem",cartItem);
            var itemId = cartItem.id;
            var pdplow = cartItem.product_type.toLowerCase();            
            if(cartItem.product_type == "Jackets" || cartItem.product_type == "Dress Pants" || cartItem.product_type == "Long Jackets" || cartItem.product_type == "Shirt"){
              var cateFitsmartObj = jQuery.grep(fitsmartObject, function(n,i){
                return (n.category == pdplow && n.designType == cartItem.properties['_designType']);
              });
            }else{
              var cateFitsmartObj = jQuery.grep(fitsmartObject, function(n,i){
                return (n.category == pdplow);
              });
            }
            console.log("cateFitsmartObj",cateFitsmartObj);
            if(cateFitsmartObj.length > 0){
              for (const [key, value] of Object.entries(cartItem.properties)) {
                // console.log("key",key);
                // console.log(`prop >>>> ${key}: ${value}`);
                if(key != '_Shirt Size1?' && key != '_Size?' && key != "type" && key != "_Standard Size?"){
                  if(cateFitsmartObj[0][key] && (cateFitsmartObj[0][key] != cartItem.properties[key])){
                    if(key == '_Body Type?' || key == '_Height?' || key == '_Hip?' || key == '_Silhouette?' || key == '_Preferred Fit?' || key == '_Shoulder Type?' || key == '_Shirt Size?' || key == '_Size?' || key == 'type' || key == '_Standard Size?'){
                      cartItem.properties[key] = cateFitsmartObj[0][key];
                      console.log("key",key);
                      needToUpdateCart = true;
                    }
                  }
                }else if(key == "_Standard Size?"){
                  // console.log("inside SS");
                  if(cateFitsmartObj[0]['_Size?'] && (cateFitsmartObj[0]['_Size?'] != cartItem.properties[key])){
                    cartItem.properties[key] = cateFitsmartObj[0]['_Size?'];
                    console.log("key",key);
                    needToUpdateCart = true;
                  }
                }else if(key == "type" && (cateFitsmartObj[0]['fitSmartType'] != cartItem.properties[key])){
                  cartItem.properties[key] = cateFitsmartObj[0]['fitSmartType'];
                  console.log("key",key);
                  needToUpdateCart = true;
                }
              }
              // if(cartItem.product_type == "Shirt"){
              //   size_isRecommended = cateFitsmartObj[0]['_Shirt Size?'].isRecommended;
              // }else if((cartItem.product_type == "Jackets" || cartItem.product_type == "Sweatshirts" || cartItem.product_type == "Joggers" || cartItem.product_type.includes("Shorts")) && cartItem.properties["_designType"] == "READY_TO_WEAR"){
              //   size_isRecommended = cateFitsmartObj[0]['_Shirt Size?'].isRecommended;
              // }else if(cartItem.product_type != "Gift Card" || cartItem.product_type != "membership" || cartItem.product_type != "HOMEVISIT"){
              //   size_isRecommended = cateFitsmartObj[0]['_Size?'].isRecommended;
              // }
              if(cateFitsmartObj[0].category == "shirt" && cateFitsmartObj[0].designType == "CUSTOM_DESIGN"){
                var fitSmartSize = cateFitsmartObj[0]['_Shirt Size?'];
                var cartSize = cartItem.properties['_Shirt Size?'];
                console.log("shirt and cstm design");
                
              }else{
                var fitSmartSize = cateFitsmartObj[0]['_Size?'];
                var cartSize = cartItem.properties['_Size?'];
                console.log("else product");
                
              }              
              console.log("cartItem=>",cartItem);
              
              console.log('cateFitsmartObj-->',cateFitsmartObj[0].category );
              console.log('fitSmartSize',fitSmartSize);
              console.log('cartSize',cartSize);
              if(fitSmartSize != cartSize){
                needToUpdateCart = true;
                var pdpJson = JSON.parse(cartItem.properties['_productJson']);
                var cartfitSize = [];
                let counter = 0;
                jQuery.grep(pdpJson, function(n,i){
                  if(counter != 0){
                    return;
                  }
                  let splitArr = n.variantTitle.split(" / ");
                  let splitArrSize = splitArr[1];
                  if(splitArr.length == 1){
                    splitArrSize = splitArr[0];
                  }
                  // console.log("splitArr",splitArr);
                  if(splitArrSize == fitSmartSize && n.variantAvailability){
                    cartfitSize.push(n);
                    counter++;
                    return;
                  }
                });
                cartItem.properties['_Size?'] = fitSmartSize;
                if(cartfitSize.length){
                  itemId = parseInt(cartfitSize[0].variantID);
                }else{
                  itemSoldout = true;
                }
              }
            }
            if(itemSoldout == false){
              console.log("UPDATED cartItem.properties",cartItem.properties);
              newCartObject.push({'id': itemId,'quantity':cartItem.quantity,'properties':cartItem.properties});
            }            
            if(index == (cartItems.length - 1)){
              console.log("needToUpdateCart",needToUpdateCart,"newCartObject",newCartObject);
              if(needToUpdateCart){
                let formData = {'items': newCartObject};  
                $.ajax({
                  type: "POST",
                  url: '/cart/clear.js',
                  success: function(){
                    console.log('I cleared the cart guest!');
                    jQuery.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: formData,
                      dataType: 'json',
                      success: function(data){
                        console.log('After clearing CART ==> Product ADDED',data);
                        if(document.body.classList.contains("template-cart")) location.reload();
                      },
                      error: function(data){
                        console.log(data);
                      }
                    });   
                  },
                  dataType: 'json'
                });
              }
            }            
          });
        }
      }else{
      if(localStorage.needToAllowCustomerCartmetadata != "true"){
        // document.querySelector("[data-debug-json]").innerHTML  = `sizing update`;
        // debugger;
        // loggedin
        profileAPIData = localStorage.getItem("getprofile");
        profileAPIData = JSON.parse(profileAPIData);
        console.log("profileAPIData",profileAPIData);
        // console.log("profileAPIData.fitProfiles",profileAPIData.fitProfiles);
        fitSmartProfiles = profileAPIData.fitProfiles;
        console.log(fitSmartProfiles,"fitSmartProfiles");
        
        cartItems.forEach((cartItem,index) => {
        if (cartItem.properties._designType != "HEMMING") {
          itemSoldout = false;
          var itemProType = cartItem.product_type;
          var itemId = cartItem.id;
          var itemQty = cartItem.quantity;
          var itemDesigntype = cartItem.properties._designType;     
          // var compareDesignType = itemDesigntype === "SEMI_STITCHED" ? "CUSTOM_DESIGN" : itemDesigntype;       
          console.log("cartItem",cartItem);
          if(cartItem.product_type == "Jackets"){
            var cateFitsmartObj = [];
            if(itemDesigntype != "READY_TO_WEAR"){
              cateFitsmartObj = jQuery.grep(fitSmartProfiles, function(n,i){
                return (n.category == "Jackets" && n.designType == itemDesigntype);
              });
              console.log("if Jackets",cateFitsmartObj);
            }
          // }else if(cartItem.product_type == "Long Jackets"){
          //   var cateFitsmartObj = [];
          //   if(itemDesigntype != "READY_TO_WEAR"){
          //     cateFitsmartObj = jQuery.grep(fitSmartProfiles, function(n,i){
          //       return (n.category == "Long Jackets" && n.designType == itemDesigntype);
          //     });
          //     console.log("if Long Jackets",cateFitsmartObj);
          //   }
          }else{
              const searchCategory = itemProType.toLowerCase().trim();

                cateFitsmartObj = jQuery.grep(fitSmartProfiles, function(n){
                const categoryMatch = (n.categoryName || "").toLowerCase().trim() === searchCategory || (n.category || "").toLowerCase().replace(/_/g, " ").trim() === searchCategory;

                const designMatch = n.designType === itemDesigntype || (itemDesigntype === "SEMI_STITCHED" && n.designType === "CUSTOM_DESIGN");
                  return categoryMatch && designMatch;

              });

            // return n.designType == itemDesigntype;
            cateFitsmartObj = jQuery.grep(cateFitsmartObj, function(n,i){
            return n.designType == itemDesigntype || (itemDesigntype === "SEMI_STITCHED" && n.designType === "CUSTOM_DESIGN")
              // return n.designType == compareDesignType;
            });

            console.log("else jackets");
          }
          var cateFitsmartObjClone = cateFitsmartObj;
          if(itemProType == "Shirt"){
            cateFitsmartObjClone = jQuery.grep(fitSmartProfiles, function(n,i){
              return (n.category == "Shirts");
            });
            var cateFitsmartObjClone = jQuery.grep(cateFitsmartObjClone, function(n,i){
              return (n.category == "Shirts" && n.designType == cartItem.properties['_designType']);
            });
          }            
          // console.log('cateFitsmartObj',cateFitsmartObj);
          console.log('cateFitsmartObjClone',cateFitsmartObjClone);          
          if(cateFitsmartObj.length > 0 && !cateFitsmartObj[0]['fitsmart']['stdSize'].isRecommended && cateFitsmartObj[0]['designType'] != "READY_TO_WEAR"){
            var fitsMartSize = cateFitsmartObj[0]['fitsmart']['stdSize'].value ? cateFitsmartObj[0]['fitsmart']['stdSize'].value.toUpperCase() : cateFitsmartObj[0]['fitsmart']['stdSize'];
            
            // if(cateFitsmartObj[0].categoryName == "shirt" && cateFitsmartObj[0].designType == "CUSTOM_DESIGN"){
            if ((cateFitsmartObj[0].categoryName == "shirt" || cateFitsmartObj[0].categoryName == "shirts") && cateFitsmartObj[0].designType == "CUSTOM_DESIGN") {
              var cartSize = cateFitsmartObj[0]['fitsmart']['stdSize'].value ? cateFitsmartObj[0]['fitsmart']['stdSize'].value.toUpperCase() : cateFitsmartObj[0]['fitsmart']['stdSize'].toUpperCase();
              console.log("if > 0 -->", cartSize);
              
            }else{
              var cartSize = cartItem.properties['_Size?'];
              console.log("else  -->", cartSize);
            }
            if(cateFitsmartObj.categoryName == "relaxed t-shirts" || cateFitsmartObj.categoryName == "relaxed linen pants" || cateFitsmartObj.categoryName == "t-shirts" || cateFitsmartObj.categoryName == "wide leg pants" || cateFitsmartObj.categoryName == "oversized t-shirts" || cateFitsmartObj.categoryName == "long sleeve polo t-shirts"){
              fitsMartSize.toUpperCase();
            }
            console.log('fitsMartSize',fitsMartSize);
            console.log('cartSize',cartSize);
            
            if(fitsMartSize.toLocaleUpperCase() != cartSize && cartSize != undefined){
              needToUpdateCart = true;
              var pdpJson = JSON.parse(cartItem.properties['_productJson']);
              var cartfitSize = [];
              let counter = 0;
              jQuery.grep(pdpJson, function(n,i){
                if(counter != 0){return;}
                let splitArr = n.variantTitle.split(" / ");
                let splitArrSize = splitArr[1];
                if(splitArr.length == 1){
                  splitArrSize = splitArr[0];
                }
                // console.log("splitArrSize",splitArrSize);
                if(splitArrSize == fitsMartSize && n.variantAvailability){
                  cartfitSize.push(n);
                  counter++;
                  return;
                }
              });
              console.log("cartfitSize",cartfitSize);
              cartItem.properties['_Size?'] = fitsMartSize;
              
              if(cartfitSize.length){
                itemId = parseInt(cartfitSize[0].variantID);
              }
              else{
                itemSoldout = true;
                console.log("not available>>>>",itemId);
              }
            }
          }
          
          if(cartItem.product_type == "membership" && cartItem.id != document.querySelector(`[data-membership-product-id]`).dataset.membershipProductId){
            needToUpdateCart = true;
            itemId = document.querySelector(`[data-membership-product-id]`).dataset.membershipProductId;
          }
          // change props for profile questions
          // if(cateFitsmartObjClone.length){
          //   for (const [key, value] of Object.entries(cartItem.properties)){
          //     if(cateFitsmartObjClone[0]['fitsmart']){
          //       if(key == '_Body Type?' && cateFitsmartObjClone[0]['fitsmart']["bodyShape"] && (cateFitsmartObjClone[0]['fitsmart']["bodyShape"].value != cartItem.properties[key])){
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["bodyShape"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(key == '_Height?' && cateFitsmartObjClone[0]['fitsmart']["height"] && (cateFitsmartObjClone[0]['fitsmart']["height"].value != cartItem.properties[key])){
          //         console.log("_Height_Height>>>>",cateFitsmartObjClone[0]['fitsmart']["height"].value);
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["height"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(key == '_Preferred Fit?' && cateFitsmartObjClone[0]['fitsmart']["fit"] && (cateFitsmartObjClone[0]['fitsmart']["fit"].value != cartItem.properties[key])){
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["fit"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(itemProType == 'Smartpants'){
          //         if(key == '_Hip?' && cateFitsmartObjClone[0]['fitsmart']["hipClass"] && (cateFitsmartObjClone[0]['fitsmart']["hipClass"].value != cartItem.properties[key])){
          //           cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["hipClass"].value;
          //           needToUpdateCart = true;
          //         }
          //       }else{
          //         if(key == '_Hip?' && cateFitsmartObjClone[0]['fitsmart']["hipClass"] && (cateFitsmartObjClone[0]['fitsmart']["hipClass"].value != cartItem.properties[key])){
          //           cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["hipClass"].value;
          //           needToUpdateCart = true;
          //         }
          //       }
          //       if(key == '_Shoulder Type?' && cateFitsmartObjClone[0]['fitsmart']["shoulderType"] && (cateFitsmartObjClone[0]['fitsmart']["shoulderType"].value != cartItem.properties[key])){
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["shoulderType"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(key == '_Shirt Size?' && cateFitsmartObjClone[0]['fitsmart']["stdSize"] && (cateFitsmartObjClone[0]['fitsmart']["stdSize"].value != cartItem.properties[key])){
          //         console.log("if _Shirt Size");
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["stdSize"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(key == '_Standard Size?' && cateFitsmartObjClone[0]['fitsmart']["stdSize"] && (cateFitsmartObjClone[0]['fitsmart']["stdSize"].value != cartItem.properties[key])){
          //         console.log("if _Standard Size");
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["stdSize"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(key == '_Silhouette?' && cateFitsmartObjClone[0]['fitsmart']["silhouette"] && (cateFitsmartObjClone[0]['fitsmart']["silhouette"].value != cartItem.properties[key])){
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['fitsmart']["silhouette"].value;
          //         needToUpdateCart = true;
          //       }
          //       if(key == 'type' && (cateFitsmartObjClone[0]['type'] != cartItem.properties[key])){
          //         console.log("inside",key,cateFitsmartObjClone[0]['type'],cartItem.properties[key]);
          //         cartItem.properties[key] = cateFitsmartObjClone[0]['type'];
          //         needToUpdateCart = true;
          //       }
          //     }
          //   }
          // }  
          // fixed change props for profile questions
          if (cateFitsmartObjClone.length && cateFitsmartObjClone[0].fitsmart) {
            const fitsmart = cateFitsmartObjClone[0].fitsmart;

            const updateProp = (propKey, fsKey) => {
              if (
                fitsmart[fsKey] &&
                fitsmart[fsKey].value &&
                cartItem.properties[propKey] !== fitsmart[fsKey].value
              ) {
                cartItem.properties[propKey] = fitsmart[fsKey].value;
                needToUpdateCart = true;
              }
            };

            updateProp('_Body Type?', 'bodyShape');
            updateProp('_Height?', 'height');
            updateProp('_Preferred Fit?', 'fit');
            updateProp('_Hip?', 'hipClass');
            updateProp('_Shoulder Type?', 'shoulderType');
            updateProp('_Shirt Size?', 'stdSize');
            updateProp('_Standard Size?', 'stdSize');
            updateProp('_Silhouette?', 'silhouette');

            // Special case: type
            if (
              cateFitsmartObjClone[0].type &&
              cartItem.properties['type'] !== cateFitsmartObjClone[0].type
            ) {
              cartItem.properties['type'] = cateFitsmartObjClone[0].type;
              needToUpdateCart = true;
            }
          } 
          if(itemSoldout == false){
            newCartObject.push({'id': itemId,'quantity':1,'properties':cartItem.properties});
          }
          if(index == (cartItems.length - 1)){
            console.log("needToUpdateCart",needToUpdateCart,"newCartObject",newCartObject);
            if(needToUpdateCart && newCartObject.length > 0){
              console.log("newCartObject==>",newCartObject);
              
              // document.querySelector("[data-debug-json]").innerHTML  = `needToUpdateCart-->${needToUpdateCart}  JSON ==>  ` + JSON.stringify(newCartObject);
              // debugger;
              let formData = {'items': newCartObject};
              $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function(blankCart){
                  console.log('I cleared the cart login view!',blankCart);
                  // debugger;
                  jQuery.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: formData,
                    dataType: 'json',
                    success: function(data){
                      console.log('After clearing CART ==> Product ADDED',data);
                      // debugger;
                      if(localStorage.needToAllowCustomerCartmetadata != "true"){
                        if(document.body.classList.contains("template-cart")) location.reload();
                        // document.querySelector("[data-debug-json]").innerHTML  = `sizing updated, duplicate tab`;
                      }
                      // else{
                      //   console.log("unifyCartInit calling from here");
                      //   unifyCartInit(data); // cart object
                      // }
                    },
                    error: function(data){
                      console.log(data);
                    }
                  });   
                },
                dataType: 'json'
              });
            }else{
              console.log("else needToUpdateCart");
              
              // // needToUpdateCart == false
              // if(localStorage.loginPageVisited == "true" && localStorage.needToReloadForCart == "true"){
              //   // location.reload();
              //   localStorage.setItem("needToReloadForCart",false);
              // }
            }
          }
        }
        });
      } // localStorage.needToAllowCustomerCartmetadata != "true" -- end
      } // notlogged - loggedin condition END
      if(needToUpdateCart == false){
        console.log("needToUpdateCart",needToUpdateCart);
        
        if(document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)")) document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)").classList.remove("disabled");
      }
    },
    error: function(data) {
      console.log("Error"); 
    }
  });
}
/*
=================================================
CART PAGE FITSMART MANAGE ======> END
=================================================
*/

/*
=================================================
CART PAGE create measurement ======> START
=================================================
*/
function cartPageManageFitsmartLoginView(){
  console.log("cartPageManageFitsmartLoginView>>>>>>>");
  profileAPIData = localStorage.getItem("getprofile");
  profileAPIData = JSON.parse(profileAPIData);
  console.log("profileAPIData",profileAPIData);
  
  if (profileAPIData == null) {
    if(document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)")) document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)").classList.remove("disabled");
  } else {
  fitSmartProfiles = profileAPIData.fitProfiles;

  $.ajax({
    url: '/cart.js',
    type: 'GET',
    contentType: "application/json",
    dataType: "json",
    success: function(data) {
      var cartItemsObjs = data.items;
      const cartCountDot = document.querySelector(".Header__CartDot");
      const cartCountDotMobile = document.querySelector(".cart-count");
      if (cartItemsObjs.length <= 0) {
        // console.log(cartCountDotMobile,"cartCountDotMobile");
        if (cartCountDot.classList.contains("is-visible")) {
        // console.log(cartCountDot,"cartCountDot");
          cartCountDot.classList.remove("is-visible");
        }
        // console.log(cartCountDotMobile.innerText,"");
        cartCountDotMobile.classList.add("hide");
      }
      console.log("cartItemsObjs",cartItemsObjs);
      console.log('not any profile');

      cartItemsObjs.forEach((item, index) => {
        if (item.properties && item.properties.type === "STANDARD") {
          if(document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)")) document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)").classList.remove("disabled");
        }
      });

      var measureDataObj = [];
      var hasShirt = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Shirts' && n.designType == 'CUSTOM_DESIGN');
      });
      var hasRTW = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Shirts' && n.designType == 'READY_TO_WEAR');
      });
      var hasJeans = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Jeans' );
      });
      var hasTShirts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'TShirts');
      });
      var hasRTShirts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'RELAXED_TSHIRTS');
      });
      var hasOverSTShirts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'OVERSIZED_TSHIRTS');
      });
      var hasLongSleevPTShirts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'LONG_SLEEVE_POLO_TSHIRTS');
      });
      var hasBundi = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'BUNDI');
      });
      var hasMidRiseDP = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'MID_RISE_DRESS_PANTS');
      });
      var hasSuitBlazer = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'SUIT_BLAZER' && n.designType == 'SEMI_STITCHED' );
      });
      var hasJaHemming = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Jackets' && n.designType == 'HEMMING' );
      });
      var hasJackets_semi = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Jackets' && n.designType == 'SEMI_STITCHED' );
      });
      var hasJacketsRTW = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Jackets' && n.designType == 'READY_TO_WEAR' );
      });
      var hasSTJacketsRTW = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'SOFT_TAILORED_JACKETS' && n.designType == 'READY_TO_WEAR' );
      });
      var hasKurtaRTW = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'KURTA' && n.designType == 'READY_TO_WEAR' );
      });
      var hasChinosRTW = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Chinos' && n.designType == 'READY_TO_WEAR' );
      });
      var hasChinosHemming = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Chinos' && n.designType == 'HEMMING' );
      });
      var hasLongJackets_semi = jQuery.grep(fitSmartProfiles, function(n){
        return (((n.categoryName || "").toLowerCase().trim() === "long jackets" || (n.category || "").toLowerCase().replace(/_/g, " ").trim() === "long jackets") && n.designType === "SEMI_STITCHED");
      });
      var hasNdp = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'NEAPOLITAN_DRESS_PANTS');
      });
      var hasRNP = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'RELAXED_NEAPOLITAN_PANTS');
      });
      var hasDP = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'DRESS_PANTS' && n.designType == 'SEMI_STITCHED');
      });
      var hasHDP = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'DRESS_PANTS' && n.designType == 'HEMMING');
      });
      var hasChinos = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Chinos' && n.designType == 'SEMI_STITCHED');
      });
      var hasKp = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Knitpants');
      });
      var hasSp = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'SMARTPANTS');
      });
      var hasLp = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'LINEN_PANTS');
      });
      var hasWLp = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'WIDE_LEG_PANTS');
      });
      var hasRLp = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'RELAXED_LINEN_PANTS');
      });
      var hasPentNewCatSD = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'STRETCH_DENIM');
      });
      var hasMidRSJeans = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'MID_RISE_STRETCH_JEANS');
      });
      var hasMidRRJeans = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'MID_RISE_RIGID_JEANS');
      });
      var hasPentNewCatRD = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'RIGID_DENIM');
      });
      var hasPentNewCatCC = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'CASUAL_CHINOS');
      });
      var hasPentNewCatLP = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'LOUNGE_PANTS');
      });
      var hasMidRiseLP = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'MID_RISE_LOUNGE_PANTS');
      });
      var hasFatiguePant = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'FATIGUE_PANTS');
      });
      var hasPentNewCatPC = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'PLEATED_CHINOS');
      });
      var hasSweatshirts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Sweatshirts');
      });
      var hasSweaters = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Sweaters');
      });
      var hasJoggers = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Joggers');
      });
      var hasShackets = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'Shackets');
      });
      var hasLinenShorts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'LINEN_SHORTS');
      });
      var hasWashedShorts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'WASHED_SHORTS');
      });
      var hasLoungeShorts = jQuery.grep(fitSmartProfiles, function(n,i){
        return (n.category == 'LOUNGE_SHORTS');
      });
      // get fitSmart localStorage object for BODYTYPE, HEIGHT, HIP
      var localFitsmart = localStorage.fitsmartobjNew ? JSON.parse(localStorage.fitsmartobjNew) : null;
      if(localFitsmart != null && localFitsmart.length > 0){
        localFitsmart = jQuery.grep(localFitsmart, function(n,i){
          return ( n.designType != 'READY_TO_WEAR');
        });
      }        
      for(var i = 0;i < cartItemsObjs.length;i++){
        var cartItemsObj = cartItemsObjs[i];
        console.log(cartItemsObj,"cartItemsObj--809");
        
        if(cartItemsObj.product_type != "Gift Card" || cartItemsObj.product_type != "membership" || cartItemsObj.product_type != "HOMEVISIT"){
          if(cartItemsObj.product_type == "Shirt" && cartItemsObj.properties['_designType'] == 'READY_TO_WEAR' ){
          //   console.log('hasRTW',hasRTW);
          //   if(hasRTW.length < 1 || (hasRTW.length > 0 && hasRTW[0].fitProfileId == null)){
          //     var RTWData = {
          //     "gender": "Male",
          //     "category": "Shirts",
          //     "brand":"BOM",
          //     "designType":'READY_TO_WEAR',
          //     "fitSmart": {
          //     "stdSize": cartItemsObj.properties['_size']
          //     }
          //     }
          //     var haRTW = jQuery.grep(measureDataObj, function(n,i){
          //       return (n.category == 'Shirts' && n.designType == 'READY_TO_WEAR');
          //     });
          //     if(haRTW.length == 0){
          //       measureDataObj.push(RTWData);
          //       console.log("RTW shirt",measureDataObj);
          //     }
          //   }
          //   console.log("RTW shirt data",RTWData);
          }
          else if(cartItemsObj.product_type == "Shirt"){
            if(hasShirt.length < 1 || (hasShirt.length > 0 && hasShirt[0].fitProfileId == null)){
              let localFitsmartShirt = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'shirt' && n.designType != 'READY_TO_WEAR');
              });
              let type = localFitsmartShirt[0].fitSmartType;
              var shirtData = {
              "gender": "Male",
              "category": "Shirts",
              "brand":"BOM",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartShirt[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": localFitsmartShirt[0]['_Shirt Size?'],
              "fit": localFitsmartShirt[0]['_Preferred Fit?'],
              "shoulderType": localFitsmartShirt[0]['_Shoulder Type?']
              }
              }
              if(type == "STANDARD"){
                delete shirtData.fitSmart.bodyShape;
                delete shirtData.fitSmart.hipClass;
                delete shirtData.fitSmart.height;
                delete shirtData.fitSmart.fit;
                delete shirtData.fitSmart.shoulderType;
              }                
              var shirtObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Shirts' && n.designType != 'READY_TO_WEAR');
              });
              if(shirtObj.length == 0){
                measureDataObj.push(shirtData);
              }
              console.log("custom Shirt",measureDataObj);
            }
          }
          else if(cartItemsObj.product_type == "Jeans"){
            if(hasJeans.length < 1 || (hasJeans.length > 0 && hasJeans[0].fitProfileId == null)){
              let localFitsmartJeans = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'jeans');
              });
              let type = localFitsmartJeans[0].fitSmartType;
              var jeansData = {
              "gender": "Male",
              "category": "Jeans",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartJeans[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete jeansData.fitSmart.bodyShape;
                delete jeansData.fitSmart.hipClass;
                delete jeansData.fitSmart.height;
              }
              var jeansObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Jeans');
              });
              if(jeansObj.length == 0){
                measureDataObj.push(jeansData);
              }
            }
          }
          else if(cartItemsObj.product_type == "T-Shirts"){
            if(hasTShirts.length < 1 || (hasTShirts.length > 0 && hasTShirts[0].fitProfileId == null)){
              let localFitsmartTSHIRT = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 't-shirts');
              });
              let type = localFitsmartTSHIRT[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": "TShirts",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartTSHIRT[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var tshirtObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'TShirts');
              });
              if(tshirtObj.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Relaxed T-Shirts"){
            if(hasRTShirts.length < 1 || (hasRTShirts.length > 0 && hasRTShirts[0].fitProfileId == null)){
              let localFitsmartRTSHIRT = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'relaxed t-shirts');
              });
              let type = localFitsmartRTSHIRT[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": "RELAXED_TSHIRTS",
              "brand":"BOM",
              "fit": "NA",
              "designType":'HEMMING',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartRTSHIRT[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var relaxedtshirtObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'RELAXED_TSHIRTS');
              });
              if(relaxedtshirtObj.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Oversized T-Shirts"){
            if(hasOverSTShirts.length < 1 || (hasOverSTShirts.length > 0 && hasOverSTShirts[0].fitProfileId == null)){
              let localFitsmartOverSTSHIRT = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'oversized t-shirts');
              });
              let type = localFitsmartOverSTSHIRT[0].fitSmartType;
              var otsData = {
              "gender": "Male",
              "category": "OVERSIZED_TSHIRTS",
              "brand":"BOM",
              "fit": "NA",
              "designType":'HEMMING',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartOverSTSHIRT[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete otsData.fitSmart.bodyShape;
                delete otsData.fitSmart.hipClass;
                delete otsData.fitSmart.height;
              }
              var otshirtObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'OVERSIZED_TSHIRTS');
              });
              if(otshirtObj.length == 0){
                measureDataObj.push(otsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Long Sleeve Polo T-Shirts"){
            if(hasLongSleevPTShirts.length < 1 || (hasLongSleevPTShirts.length > 0 && hasLongSleevPTShirts[0].fitProfileId == null)){
              let localFitsmartLongPoloTSHIRT = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'long sleeve polo t-shirts');
              });
              let type = localFitsmartLongPoloTSHIRT[0].fitSmartType;
              var lsptsData = {
              "gender": "Male",
              "category": "LONG_SLEEVE_POLO_TSHIRTS",
              "brand":"BOM",
              "fit": "NA",
              "designType":'HEMMING',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartLongPoloTSHIRT[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete lsptsData.fitSmart.bodyShape;
                delete lsptsData.fitSmart.hipClass;
                delete lsptsData.fitSmart.height;
              }
              var lsptshirtObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'LONG_SLEEVE_POLO_TSHIRTS');
              });
              if(lsptshirtObj.length == 0){
                measureDataObj.push(lsptsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Bundi"){
            if(hasBundi.length < 1 || (hasBundi.length > 0 && hasBundi[0].fitProfileId == null)){
              let localFitsmartBUNDI = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'bundi');
              });
              let type = localFitsmartBUNDI[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": "BUNDI",
              "designType": "SEMI_STITCHED",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartBUNDI[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var bundiObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Bundi');
              });
              if(bundiObj.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Mid Rise Dress Pants"){
            if(hasMidRiseDP.length < 1 || (hasMidRiseDP.length > 0 && hasMidRiseDP[0].fitProfileId == null)){
              let localFitsmartMidRiseDP = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'mid rise dress pants');
              });
              let type = localFitsmartMidRiseDP[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": "MID_RISE_DRESS_PANTS",
              "designType": "SEMI_STITCHED",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartMidRiseDP[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var bundiObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Mid Rise Dress Pants');
              });
              if(bundiObj.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Stretch Denim"){
            if(hasPentNewCatSD.length < 1 || (hasPentNewCatSD.length > 0 && hasPentNewCatSD[0].fitProfileId == null)){
              let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pendNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == cat);
              });
              if(pendNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Mid Rise Stretch Jeans"){
            if(hasMidRSJeans.length < 1 || (hasMidRSJeans.length > 0 && hasMidRSJeans[0].fitProfileId == null)){
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": 'MID_RISE_STRETCH_JEANS',
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pendNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == "MID_RISE_STRETCH_JEANS");
              });
              if(pendNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Mid Rise Rigid Jeans"){
            if(hasMidRRJeans.length < 1 || (hasMidRRJeans.length > 0 && hasMidRRJeans[0].fitProfileId == null)){
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": 'MID_RISE_RIGID_JEANS',
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pendNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == "MID_RISE_RIGID_JEANS");
              });
              if(pendNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Rigid Denim"){
            if(hasPentNewCatRD.length < 1 || (hasPentNewCatRD.length > 0 && hasPentNewCatRD[0].fitProfileId == null)){
              let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pendNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == cat);
              });
              if(pendNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Casual Chinos"){
            if(hasPentNewCatCC.length < 1 || (hasPentNewCatCC.length > 0 && hasPentNewCatCC[0].fitProfileId == null)){
              let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pendNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == cat);
              });
              if(pendNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Pleated Chinos"){
            if(hasPentNewCatPC.length < 1 || (hasPentNewCatPC.length > 0 && hasPentNewCatPC[0].fitProfileId == null)){
              let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pentNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == cat);
              });
              if(pentNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Lounge Pants"){
            if(hasPentNewCatLP.length < 1 || (hasPentNewCatLP.length > 0 && hasPentNewCatLP[0].fitProfileId == null)){
              let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pentNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == cat);
              });
              if(pentNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Mid Rise Lounge Pants"){
            if(hasMidRiseLP.length < 1 || (hasMidRiseLP.length > 0 && hasMidRiseLP[0].fitProfileId == null)){
              let cat = "MID_RISE_LOUNGE_PANTS";
              let localFitsmartDenims = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartDenims[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDenims[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var MidRiseLP = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == cat);
              });
              if(MidRiseLP.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Fatigue Pants"){
            if(hasFatiguePant.length < 1 || (hasFatiguePant.length > 0 && hasFatiguePant[0].fitProfileId == null)){
              // let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartFP = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartFP[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": "FATIGUE_PANTS",
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartFP[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var pentNewCat = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == "FATIGUE_PANTS");
              });
              if(pentNewCat.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          // else if(cartItemsObj.product_type == "Sweatshirts"){
          //   console.log('hasSweatshirts',hasSweatshirts);
          //   if(hasSweatshirts.length < 1 || (hasSweatshirts.length > 0 && hasSweatshirts[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "Sweatshirts",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var haRTWSweatshirts = jQuery.grep(measureDataObj, function(n,i){
          //   return (n.category == 'Sweatshirts');
          //   });
          //   if(haRTWSweatshirts.length == 0){
          //   measureDataObj.push(RTWData);
          //   console.log("RTW Sweatshirts",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Sweatshirts data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Sweaters"){
          //   console.log('hasSweaters',hasSweaters);
          //   if(hasSweaters.length < 1 || (hasSweaters.length > 0 && hasSweaters[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "Sweaters",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var haRTWSweaters = jQuery.grep(measureDataObj, function(n,i){
          //   return (n.category == 'Sweaters');
          //   });
          //   if(haRTWSweaters.length == 0){
          //   measureDataObj.push(RTWData);
          //   console.log("RTW Sweaters",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Sweaters data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Joggers"){
          //   console.log('hasJoggers',hasJoggers);
          //   if(hasJoggers.length < 1 || (hasJoggers.length > 0 && hasJoggers[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "Joggers",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var haRTWJoggers = jQuery.grep(measureDataObj, function(n,i){
          //   return (n.category == 'Joggers');
          //   });
          //   if(haRTWJoggers.length == 0){
          //   measureDataObj.push(RTWData);
          //   console.log("RTW Joggers",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Joggers data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Shackets"){
          //   console.log('hasShackets',hasShackets);
          //   if(hasShackets.length < 1 || (hasShackets.length > 0 && hasShackets[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "SHACKETS",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var hasShorts = jQuery.grep(measureDataObj, function(n,i){
          //     return (n.category == 'SHACKETS');
          //   });
          //   if(hasShorts.length == 0){
          //     measureDataObj.push(RTWData);
          //     console.log("RTW Shackets",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Shackets data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Linen Shorts"){
          //   console.log('hasLinenShorts',hasLinenShorts);
          //   if(hasLinenShorts.length < 1 || (hasLinenShorts.length > 0 && hasLinenShorts[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "LINEN_SHORTS",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var hasShorts = jQuery.grep(measureDataObj, function(n,i){
          //     return (n.category == 'LINEN_SHORTS');
          //   });
          //   if(hasShorts.length == 0){
          //     measureDataObj.push(RTWData);
          //     console.log("RTW Shorts",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Shorts data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Washed Shorts"){
          //   console.log('hasWashedShorts',hasWashedShorts);
          //   if(hasWashedShorts.length < 1 || (hasWashedShorts.length > 0 && hasWashedShorts[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "WASHED_SHORTS",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var hasShorts = jQuery.grep(measureDataObj, function(n,i){
          //     return (n.category == 'WASHED_SHORTS');
          //   });
          //   if(hasShorts.length == 0){
          //     measureDataObj.push(RTWData);
          //     console.log("RTW Shorts",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Shorts data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Lounge Shorts"){
          //   console.log('hasLoungeShorts',hasLoungeShorts);
          //   if(hasLoungeShorts.length < 1 || (hasLoungeShorts.length > 0 && hasLoungeShorts[0].fitProfileId == null)){
          //   var RTWData = {
          //   "gender": "Male",
          //   "category": "LOUNGE_SHORTS",
          //   "brand":"BOM",
          //   "designType":'READY_TO_WEAR',
          //   "fitSmart": {
          //   "stdSize": cartItemsObj.properties['_size'].toLocaleLowerCase()
          //   }
          //   }
          //   var hasShorts = jQuery.grep(measureDataObj, function(n,i){
          //     return (n.category == 'LOUNGE_SHORTS');
          //   });
          //   if(hasShorts.length == 0){
          //     measureDataObj.push(RTWData);
          //     console.log("RTW Shorts",measureDataObj);
          //   }
          //   }
          //   console.log("RTW Shorts data",RTWData);
          // }
          // else if(cartItemsObj.product_type == "Soft Tailored Jackets" && cartItemsObj.properties['_designType'] == 'READY_TO_WEAR'){
          //   console.log("hasSTJacketsRTW",hasSTJacketsRTW);
          //   if(hasSTJacketsRTW.length < 1 || (hasSTJacketsRTW.length > 0 && hasSTJacketsRTW[0].fitProfileId == null)){
          //     var RTWData = {
          //     "gender": "Male",
          //     "category": "SOFT_TAILORED_JACKETS",
          //     "brand":"BOM",
          //     "designType":'READY_TO_WEAR',
          //     "fitSmart": {
          //     "stdSize": cartItemsObj.properties['_size']
          //     }
          //     }
          //     var hasSTJackets = jQuery.grep(measureDataObj, function(n,i){
          //       return (n.category == 'SOFT_TAILORED_JACKETS' && n.designType == 'READY_TO_WEAR');
          //     });
          //     console.log("hasSTJackets",hasSTJackets);
          //     if(hasSTJackets.length == 0){
          //       measureDataObj.push(RTWData);
          //       console.log("ST jackets",measureDataObj);
          //     }
          //   }
          // }
          // else if(cartItemsObj.product_type == "Kurta" && cartItemsObj.properties['_designType'] == 'READY_TO_WEAR'){
          //   console.log("hasKurtaRTW",hasKurtaRTW);
          //   if(hasKurtaRTW.length < 1 || (hasKurtaRTW.length > 0 && hasKurtaRTW[0].fitProfileId == null)){
          //     var RTWData = {
          //     "gender": "Male",
          //     "category": "KURTA",
          //     "brand":"BOM",
          //     "designType":'READY_TO_WEAR',
          //     "fitSmart": {
          //     "stdSize": cartItemsObj.properties['_size']
          //     }
          //     }
          //     var hasKurta = jQuery.grep(measureDataObj, function(n,i){
          //       return (n.category == 'KURTA' && n.designType == 'READY_TO_WEAR');
          //     });
          //     console.log("hasKurta",hasKurta);
          //     if(hasKurta.length == 0){
          //       measureDataObj.push(RTWData);
          //       console.log("Kurta",measureDataObj);
          //     }
          //   }
          // }
          // else if(cartItemsObj.product_type == "Jackets" && cartItemsObj.properties['_designType'] == 'READY_TO_WEAR'){
          //   console.log("hasJacketsRTW",hasJacketsRTW);
          //   if(hasJacketsRTW.length < 1 || (hasJacketsRTW.length > 0 && hasJacketsRTW[0].fitProfileId == null)){
          //     var RTWData = {
          //     "gender": "Male",
          //     "category": "Jackets",
          //     "brand":"BOM",
          //     "designType":'READY_TO_WEAR',
          //     "fitSmart": {
          //     "stdSize": cartItemsObj.properties['_size']
          //     }
          //     }
          //     var haRTWJackets = jQuery.grep(measureDataObj, function(n,i){
          //       return (n.category == 'Jackets' && n.designType == 'READY_TO_WEAR');
          //     });
          //     console.log("haRTWJackets",haRTWJackets);
          //     if(haRTWJackets.length == 0){
          //       measureDataObj.push(RTWData);
          //       console.log("RTW jackets",measureDataObj);
          //     }
          //   }
          // }
          else if(cartItemsObj.product_type == "Jackets" && cartItemsObj.properties['_designType'] == 'HEMMING'){
            if(hasJaHemming.length < 1 || (hasJaHemming.length > 0 && hasJaHemming[0].fitProfileId == null)){
              let localFitsmartJacketHemming = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'jackets' && n.designType == 'HEMMING');
              });
              let type = localFitsmartJacketHemming[0].fitSmartType;
              var JacketsHemming = {
              "gender": "Male",
              "category": "Jackets",
              "brand":"BOM",
              "fit": cartItemsObj.properties['_Preferred Fit?'],
              "designType":'HEMMING',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartJacketHemming[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete JacketsHemming.fitSmart.bodyShape;
                delete JacketsHemming.fitSmart.hipClass;
                delete JacketsHemming.fitSmart.height;
              }
              var JacketsHemming1 = jQuery.grep(measureDataObj, function(n,i){
                return ( n.category == 'Jackets' && n.designType == 'HEMMING');
              });
              if(JacketsHemming1.length == 0){
                measureDataObj.push(JacketsHemming);
              }
            }
          }
          else if(cartItemsObj.product_type == "Jackets" && cartItemsObj.properties['_designType'] == 'SEMI_STITCHED'){
            if(hasJackets_semi.length < 1 || (hasJackets_semi.length > 0 && hasJackets_semi[0].fitProfileId == null)){
              let localFitsmartJacketSemi = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'jackets' && n.designType == 'SEMI_STITCHED');
              });
              let type = localFitsmartJacketSemi[0].fitSmartType;
              var Jacketssemi = {
              "gender": "Male",
              "category": "Jackets",
              "brand":"BOM",
              "fit": cartItemsObj.properties['_Preferred Fit?'],
              "designType": 'SEMI_STITCHED',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartJacketSemi[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete Jacketssemi.fitSmart.bodyShape;
                delete Jacketssemi.fitSmart.hipClass;
                delete Jacketssemi.fitSmart.height;
              }
              var Jacketssemi1 = jQuery.grep(measureDataObj, function(n,i){
                return ( n.category == 'Jackets' && n.designType == 'SEMI_STITCHED');
              });
              if(Jacketssemi1.length == 0){                        
                measureDataObj.push(Jacketssemi);
              }
            }
          }
          else if(cartItemsObj.product_type == "Suit Blazer" && cartItemsObj.properties['_designType'] == 'SEMI_STITCHED'){
            if(hasSuitBlazer.length < 1 || (hasSuitBlazer.length > 0 && hasSuitBlazer[0].fitProfileId == null)){
              let localFitsmartJacketSemi = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'suit blazer' && n.designType == 'SEMI_STITCHED');
              });
              let type = localFitsmartJacketSemi[0].fitSmartType;
              var suitblazer = {
              "gender": "Male",
              "category": "SUIT_BLAZER",
              "brand":"BOM",
              "fit": cartItemsObj.properties['_Preferred Fit?'],
              "designType": 'SEMI_STITCHED',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartJacketSemi[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete suitblazer.fitSmart.bodyShape;
                delete suitblazer.fitSmart.hipClass;
                delete suitblazer.fitSmart.height;
              }
              var suitblazer1 = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'SUIT_BLAZER');
              });
              if(suitblazer1.length == 0){                        
                measureDataObj.push(suitblazer);
              }
            }
          }
          else if(cartItemsObj.product_type == "Long Jackets" && cartItemsObj.properties['_designType'] == 'SEMI_STITCHED'){
            if(hasLongJackets_semi.length < 1 || (hasLongJackets_semi.length > 0 && hasLongJackets_semi[0].fitProfileId == null)){
              // let localFitsmartLongJacketSemi = jQuery.grep(localFitsmart, function(n,i){
              //   return (n.category == 'LONG_JACKETS' && n.designType == 'SEMI_STITCHED');
              // });
              let localFitsmartLongJacketSemi = jQuery.grep(localFitsmart, function(n){
                return ((n.category || "").toLowerCase().trim() === "long jackets" && n.designType === "SEMI_STITCHED");
              });
              console.log(localFitsmartLongJacketSemi,"localFitsmartLongJacketSemi");
              
              if (!localFitsmartLongJacketSemi.length) {
                console.log("Long Jackets not found in localFitsmart", localFitsmart);
                return;
              }

              let type = localFitsmartLongJacketSemi[0].fitSmartType;
              var Jacketssemi = {
              "gender": "Male",
              "category": "LONG_JACKETS",
              "brand":"BOM",
              "fit": cartItemsObj.properties['_Preferred Fit?'],
              "designType": 'SEMI_STITCHED',
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartLongJacketSemi[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete Jacketssemi.fitSmart.bodyShape;
                delete Jacketssemi.fitSmart.hipClass;
                delete Jacketssemi.fitSmart.height;
              }
              var Jacketssemi1 = jQuery.grep(measureDataObj, function(n,i){
                return ( n.category == 'LONG_JACKETS' && n.designType == 'SEMI_STITCHED');
              });
              if(Jacketssemi1.length == 0){                        
                measureDataObj.push(Jacketssemi);
              }
            }
          }
          else if(cartItemsObj.product_type == "Neapolitan Dress Pants"){
            if(hasNdp.length < 1 || (hasNdp.length > 0 && hasNdp[0].fitProfileId == null)){
              let localFitsmartNeaPants = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'neapolitan dress pants');
              });
              let type = localFitsmartNeaPants[0].fitSmartType;
              var npData = {
              "gender": "Male",
              "category": "NEAPOLITAN_DRESS_PANTS",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartNeaPants[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete npData.fitSmart.bodyShape;
                delete npData.fitSmart.hipClass;
                delete npData.fitSmart.height;
              }
              var neaPolitan = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'NEAPOLITAN_DRESS_PANTS');
              });
              if(neaPolitan.length == 0){
                measureDataObj.push(npData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Relaxed Neapolitan Pants"){
            if(hasRNP.length < 1 || (hasRNP.length > 0 && hasRNP[0].fitProfileId == null)){
              let localFitsmartRelNeaPants = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'relaxed neapolitan pants');
              });
              let type = localFitsmartRelNeaPants[0].fitSmartType;
              var rnpData = {
              "gender": "Male",
              "category": "RELAXED_NEAPOLITAN_PANTS",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "designType": 'SEMI_STITCHED',
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartRelNeaPants[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete rnpData.fitSmart.bodyShape;
                delete rnpData.fitSmart.hipClass;
                delete rnpData.fitSmart.height;
              }
              var RelneaPolitan = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'RELAXED_NEAPOLITAN_PANTS');
              });
              if(RelneaPolitan.length == 0){
                measureDataObj.push(rnpData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Dress Pants" && cartItemsObj.properties['_designType'] == 'HEMMING'){
            if(hasHDP.length < 1 || (hasHDP.length > 0 && hasHDP[0].fitProfileId == null)){
              let localFitsmartHDressPants = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'dress pants' && n.designType == 'HEMMING');
              });
              let type = localFitsmartHDressPants[0].fitSmartType;
              var hdpData = {
              "gender": "Male",
              "category": "DRESS_PANTS",
              "brand":"BOM",
              "fit": "NA",
              "designType": "HEMMING",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartHDressPants[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete hdpData.fitSmart.bodyShape;
                delete hdpData.fitSmart.hipClass;
                delete hdpData.fitSmart.height;
              }
              var dressPent = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'DRESS_PANTS' && n.designType == 'HEMMING');
              });
              if(dressPent.length == 0){
                measureDataObj.push(hdpData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Dress Pants" && cartItemsObj.properties['_designType'] == 'SEMI_STITCHED'){
            if(hasDP.length < 1 || (hasDP.length > 0 && hasDP[0].fitProfileId == null)){
              let localFitsmartDressPants = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'dress pants' && n.designType == 'SEMI_STITCHED');
              });
              let type = localFitsmartDressPants[0].fitSmartType;
              var dpData = {
              "gender": "Male",
              "category": "DRESS_PANTS",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "designType": 'SEMI_STITCHED',
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartDressPants[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete dpData.fitSmart.bodyShape;
                delete dpData.fitSmart.hipClass;
                delete dpData.fitSmart.height;
              }
              var dressPent = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'DRESS_PANTS' && n.designType == 'SEMI_STITCHED');
              });
              if(dressPent.length == 0){
                measureDataObj.push(dpData);
              }
            }
          }
          // else if(cartItemsObj.product_type == "Dress Pants"){
          //   if(hasDP.length < 1 || (hasDP.length > 0 && hasDP[0].fitProfileId == null)){
          //     let localFitsmartDressPants = jQuery.grep(localFitsmart, function(n,i){
          //       return (n.category == 'dress pants');
          //     });
          //     let type = localFitsmartDressPants[0].fitSmartType;
          //     var dpData = {
          //     "gender": "Male",
          //     "category": "DRESS_PANTS",
          //     "brand":"BOM",
          //     "fit": "NA",
          //     "type": type,
          //     "fitSmart": {
          //     "bodyShape": localFitsmart[0]['_Body Type?'],
          //     "hipClass": localFitsmartDressPants[0]['_Hip?'],
          //     "height": localFitsmart[0]['_Height?'],
          //     "stdSize": cartItemsObj.properties['_Size?']
          //     },
          //     "silhouette": cartItemsObj.properties['_Silhouette?'],
          //     "fabricType": "NA"
          //     }
          //     if(type == "STANDARD"){
          //       delete dpData.fitSmart.bodyShape;
          //       delete dpData.fitSmart.hipClass;
          //       delete dpData.fitSmart.height;
          //     }
          //     var dressPent = jQuery.grep(measureDataObj, function(n,i){
          //       return (n.category == 'DRESS_PANTS');
          //     });
          //     if(dressPent.length == 0){
          //       measureDataObj.push(dpData);
          //     }
          //   }
          // }
          // else if(cartItemsObj.product_type == "Chinos" && cartItemsObj.properties['_designType'] == 'READY_TO_WEAR'){
          //   console.log("hasChinosRTW",hasChinosRTW);
          //   if(hasChinosRTW.length < 1 || (hasChinosRTW.length > 0 && hasChinosRTW[0].fitProfileId == null)){
          //     var RTWData = {
          //     "gender": "Male",
          //     "category": "Chinos",
          //     "brand":"BOM",
          //     "designType":'READY_TO_WEAR',
          //     "fitSmart": {
          //     "stdSize": cartItemsObj.properties['_size']
          //     }
          //     }
          //     var hasChinosR = jQuery.grep(measureDataObj, function(n,i){
          //       return (n.category == 'Chinos' && n.designType == 'READY_TO_WEAR');
          //     });
          //     console.log("hasChinosR",hasChinosR);
          //     if(hasChinosR.length == 0){
          //       measureDataObj.push(RTWData);
          //       console.log("Chinos",measureDataObj);
          //     }
          //   }
          // }
          else if(cartItemsObj.product_type == "Chinos" && cartItemsObj.properties['_designType'] == 'HEMMING'){
            if(hasChinosHemming.length < 1 || (hasChinosHemming.length > 0 && hasChinosHemming[0].fitProfileId == null)){
              let cat = cartItemsObj.product_type.replace(" ","_").toUpperCase();
              let localFitsmartChinosHemming = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == cartItemsObj.product_type.toLowerCase());
              });
              let type = localFitsmartChinosHemming[0].fitSmartType;
              var tsData = {
              "gender": "Male",
              "category": `${cat}`,
              "designType": "HEMMING",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartChinosHemming[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?'].toLowerCase()
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete tsData.fitSmart.bodyShape;
                delete tsData.fitSmart.hipClass;
                delete tsData.fitSmart.height;
              }
              var chionosHemming = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Chinos');
              });
              if(chionosHemming.length == 0){
                measureDataObj.push(tsData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Chinos" && cartItemsObj.properties['_designType'] == 'SEMI_STITCHED'){
            if(hasChinos.length < 1 || (hasChinos.length > 0 && hasChinos[0].fitProfileId == null)){
              let localFitsmartChinos = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'chinos');
              });
              let type = localFitsmartChinos[0].fitSmartType;
              var cnData = {
              "gender": "Male",
              "category": "Chinos",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartChinos[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": cartItemsObj.properties['_Silhouette?'],
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete cnData.fitSmart.bodyShape;
                delete cnData.fitSmart.hipClass;
                delete cnData.fitSmart.height;
              }
              var chinosObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Chinos');
              });
              if(chinosObj.length == 0){
                measureDataObj.push(cnData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Knitpants"){
            if(hasKp.length < 1 || (hasKp.length > 0 && hasKp[0].fitProfileId == null)){
              let localFitsmartKnitpants = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'knitpants');
              });
              let type = localFitsmartKnitpants[0].fitSmartType;
              var kpData = {
              "gender": "Male",
              "category": "Knitpants",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartKnitpants[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              "silhouette": "NA",
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete kpData.fitSmart.bodyShape;
                delete kpData.fitSmart.hipClass;
                delete kpData.fitSmart.height;
              }
              var knitObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'Knitpants');
              });
              if(knitObj.length == 0){
                measureDataObj.push(kpData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Smartpants"){
            if(hasSp.length < 1 || (hasSp.length > 0 && hasSp[0].fitProfileId == null)){
              let localFitsmartSP = jQuery.grep(localFitsmart, function(n,i){
              return (n.category == 'smartpants');
              });
              let type = localFitsmartSP[0].fitSmartType;
              var spData = {
              "gender": "Male",
              "category": "SMARTPANTS",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartSP[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              }
              if(type == "STANDARD"){
                delete spData.fitSmart.bodyShape;
                delete spData.fitSmart.hipClass;
                delete spData.fitSmart.height;
              }
              var smartObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'SMARTPANTS');
              });
              if(smartObj.length == 0){
                measureDataObj.push(spData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Linen Pants"){
            if(hasLp.length < 1 || (hasLp.length > 0 && hasLp[0].fitProfileId == null)){
              let localFitsmartLP = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'linen pants');
              });
              let type = localFitsmartLP[0].fitSmartType;
              var lpData = {
              "gender": "Male",
              "category": "LINEN_PANTS",
              "brand":"BOM",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartLP[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              // "silhouette": cartItemsObj.properties['_Silhouette?'],
              "silhouette": 'Straight',
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete lpData.fitSmart.bodyShape;
                delete lpData.fitSmart.hipClass;
                delete lpData.fitSmart.height;
              }
              var linenObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'LINEN_PANTS');
              });
              if(linenObj.length == 0){
                measureDataObj.push(lpData);
              }
            }
          }else if(cartItemsObj.product_type == "Wide Leg Pants"){
            if(hasWLp.length < 1 || (hasWLp.length > 0 && hasWLp[0].fitProfileId == null)){
              let localFitsmartLP = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'wide leg pants');
              });
              let type = localFitsmartLP[0].fitSmartType;
              
              var wlpData = {
              "gender": "Male",
              "category": "WIDE_LEG_PANTS",
              "brand":"BOM",
              "designType": "HEMMING",
              "fit": "NA",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartLP[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              // "silhouette": cartItemsObj.properties['_Silhouette?'],
              "silhouette": 'Straight',
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete wlpData.fitSmart.bodyShape;
                delete wlpData.fitSmart.hipClass;
                delete wlpData.fitSmart.height;
              }
              var linenObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'WIDE_LEG_PANTS');
              });
              if(linenObj.length == 0){
                measureDataObj.push(wlpData);
              }
            }
          }
          else if(cartItemsObj.product_type == "Relaxed Linen Pants"){
            if(hasRLp.length < 1 || (hasRLp.length > 0 && hasRLp[0].fitProfileId == null)){
              let localFitsmartRLP = jQuery.grep(localFitsmart, function(n,i){
                return (n.category == 'relaxed linen pants');
              });
              console.log("localFitsmartRLP--",localFitsmartRLP);
              
              let type = localFitsmartRLP[0].fitSmartType;
              var rlpData = {
              "gender": "Male",
              "category": "RELAXED_LINEN_PANTS",
              "brand":"BOM",
              "fit": "NA",
              "designType": "HEMMING",
              "type": type,
              "fitSmart": {
              "bodyShape": localFitsmart[0]['_Body Type?'],
              "hipClass": localFitsmartRLP[0]['_Hip?'],
              "height": localFitsmart[0]['_Height?'],
              "stdSize": cartItemsObj.properties['_Size?']
              },
              // "silhouette": cartItemsObj.properties['_Silhouette?'],
              "silhouette": 'NA',
              "fabricType": "NA"
              }
              if(type == "STANDARD"){
                delete rlpData.fitSmart.bodyShape;
                delete rlpData.fitSmart.hipClass;
                delete rlpData.fitSmart.height;
              }
              var linenObj = jQuery.grep(measureDataObj, function(n,i){
                return (n.category == 'RELAXED_LINEN_PANTS');
              });
              if(linenObj.length == 0){
                measureDataObj.push(rlpData);
              }
            }
          }
        }
      }
      console.log('measureDataObj 1745',measureDataObj,measureDataObj.length);
      if(measureDataObj.length > 0){
            measureDataObj.reverse();
            // customerMetaKey = "";
            let createMeasureOBJ = {
              "customerIdentifier": fitsmartCustomerId,
              "shopifyId": fitsmartCustomerId,
              "email": email,
              // "metadata": customerMetaKey,
              "requests": measureDataObj
            }
            console.log("createMeasureOBJ",createMeasureOBJ);
          if (measureDataObj[0].designType == "READY_TO_WEAR"){
            if(document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)")) document.querySelector(".temp-cart-btns .Cart__Checkout:not(.dont-remove-disabled)").classList.remove("disabled");
          }
          // if (measureDataObj[0].designType == "CUSTOM_DESIGN" || measureDataObj[0].designType == "SEMI_STITCHED" || measureDataObj[0].designType == "HEMMING") {
              createMeasurementFitsmart(createMeasureOBJ,customerMetaKey);
          // }
      }else{
        console.log('profile already created');
        manageCartFitsmart();
      }

    },
    error: function(data) {
      console.log("Error"); 
    }
  });
  }
}
/*
=================================================
CART PAGE create measurement ======> END
=================================================
*/

if(document.body.classList.contains("template-cart")){
  if(document.body.classList.contains("logged")){
    console.log("logges 2285");
    
    getCustomerProfileAPIData(fitsmartCustomerId,true);
  }else{
    manageCartFitsmart();
  }
}

/*
=================================================
CART PAGE getTat DELIVERY DATE ======> START
=================================================
*/
if(document.body.classList.contains("template-cart")){

  let deliveryItemArr = [];
  document.querySelectorAll(`.CartItem[data-product-id]`).forEach(item => {
    deliveryItemArr.push({
      "productId": item.dataset.productId,
      "category": getCreateMeasurementCategory(item.dataset.productType),
      "productType": item.dataset.designtype,
      "fabricCode": item.dataset.fabricId
    });
  });
  // // console.log("deliveryItemArr",deliveryItemArr);
  
  let monthsArr = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"];
  const myHeaders = new Headers();
  myHeaders.append("accept", "application/json, text/plain, */*");
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Host", `${baseUrlBsc}`);
  myHeaders.append("requesttoken", requestToken.requestToken);
  
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(deliveryItemArr)
  };
  // console.log("requestOptions",requestOptions);
  // let pincode = '?customerPincode=${pincode}';
  let pincode = '';
  if(localStorage.customerPincode != undefined){
    pincode = `?customerPincode=${localStorage.customerPincode}`;
  }else if(document.querySelector(`[data-customer-pincode]`) && document.querySelector(`[data-customer-pincode]`).dataset.customerPincode != "" && document.querySelector(`[data-customer-pincode]`).dataset.customerPincode != undefined){
    pincode = `?customerPincode=${document.querySelector(`[data-customer-pincode]`).dataset.customerPincode}`;
  }  
  fetch(`${baseUrlBsc}/order-module/getTat${pincode}`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    console.log("result",result);
    result.tatDetails.forEach(tatObj => {
      let cartItem = document.querySelector(`.CartItem[data-product-id="${tatObj.shopifyProductId}"]`);
      if(tatObj.customerDeliveryDays != null){
        let deliveryDays = tatObj.customerDeliveryDays;
        let deliveryTimestamp = Date.now() + (60*60*24*1000*deliveryDays);
        let deliveryDate = new Date(deliveryTimestamp);
        // console.log("deliveryDate",deliveryDate);
        cartItem.querySelector(`.shipping-status .shippingETAtext`).innerHTML = `Free delivery by ${deliveryDate.getDate()} ${monthsArr[deliveryDate.getMonth()]}`;
        cartItem.classList.add("show-tat");
      }else{
        let deliveryDays = tatObj.customerShipByDays;
        let deliveryTimestamp = Date.now() + (60*60*24*1000*deliveryDays);
        let deliveryDate = new Date(deliveryTimestamp);
        // console.log("deliveryDate",deliveryDate);
        cartItem.querySelector(`.shipping-status .shippingETAtext`).innerHTML = `Free shipping by ${deliveryDate.getDate()} ${monthsArr[deliveryDate.getMonth()]}`;
        cartItem.classList.add("show-tat");
      }
    });
  })
  .catch((error) => console.error(error));  
}
/*
=================================================
CART PAGE getTat DELIVERY DATE ======> END
=================================================
*/